module.exports = __webpack_public_path__ + "img/add-circle-outline.3041b26f.svg";